import { Info } from "@tamagui/lucide-icons";
import type React from "react";
import { View, XStack, type XStackProps } from "tamagui";
import tamaguiConfig from "../../tamagui.config";
import type { IconProp } from "./icons";
import { Subtext } from "./Subtext";

type TipsTextProps = Omit<XStackProps, "text"> & {
  icon?: IconProp;
  text: string;
  numberOfLines?: number;
};

export const TipsText: React.FC<TipsTextProps> = ({
  icon,
  text,
  numberOfLines,
  ...xStackProps
}) => {
  const Icon = icon ?? Info;
  return (
    <XStack maxWidth="100%" gap={"$small"} {...xStackProps}>
      {Icon && (
        <View height={tamaguiConfig.fonts.subtext.lineHeight.true}>
          <Icon
            style={{ minWidth: 16 }}
            color={"$muted"}
            size={"$size.small"}
          />
        </View>
      )}
      <Subtext lineHeight={16} fontSize={14} numberOfLines={numberOfLines}>
        {text}
      </Subtext>
    </XStack>
  );
};
